import { inputDescLimit, inputTextLimit } from '../../../helpers/inputTextLimit';
import messages from '../../../locale/messages';

const validate = values => {

    const errors = {}

    if (!values?.locationName) {
        errors.locationName = messages.required;
    } else if (values?.locationName?.trim() == "") {
        errors.locationName = messages.required;
    } else if (values?.locationName?.length > inputTextLimit) {
        errors.locationName = messages.inputFieldLimitError;
    }

    if (!values?.description) {
        errors.description = messages.required;
    } else if (values?.description?.trim() == "") {
        errors.description = messages.required;
    } else if (values?.description?.length > inputDescLimit) {
        errors.description = messages.inputDescLimitError;
    }

    return errors
}

export default validate;